module.exports = __webpack_public_path__ + "70c91a77c3a9e961c58b47e1a69fa54c.png";